import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";
import { installAuthFetch } from "@/utils/authClient";
import { initApiOrigin } from "@/lib/apiOrigin";

initApiOrigin();

// Suppress the benign "ResizeObserver loop ..." error that Radix/shadcn
// components can emit. In CRA dev this otherwise pops the red error overlay
// and blocks interaction; it is harmless to ignore.
const _isResizeObserverError = (msg) =>
  typeof msg === "string" && msg.includes("ResizeObserver loop");
window.addEventListener("error", (e) => {
  if (_isResizeObserverError(e?.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

// Send credentials (httpOnly auth cookie) with every backend fetch.
installAuthFetch();

// SEC-303: axios sendet Credentials für Same-Origin-Requests, damit das
// HttpOnly-Auth-Cookie als Auth-Träger genutzt werden kann. Cross-Origin
// (Preview) bleibt credentialless — Bearer-Header greift dort weiterhin.
axios.interceptors.request.use((config) => {
  try {
    const url = new URL(config.url || "", window.location.href);
    if (url.origin === window.location.origin && config.withCredentials === undefined) {
      config.withCredentials = true;
    }
  } catch {
    /* noop */
  }
  return config;
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
